export default "__VITE_ASSET__t13iPqiQ__"